module.exports = __webpack_public_path__ + "static/blueprint-2-ae1cf338ac7a33c57d88dc8327e5e55f.png";